module.exports = __webpack_public_path__ + "static/media/addition-not-budget-icon.76db8284.svg";